/**
 * JANIMONY.CHAT - useChats Hook
 * Custom hook for managing chats
 */

import { useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import AuthService from '../services/auth';

export const useChats = () => {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchChats = useCallback(async () => {
    const user = AuthService.getCurrentUser();
    if (!user) return;

    try {
      setLoading(true);
      const response = await API.getActiveChats(user.apiKey);
      if (response.success) {
        setChats(response.sessions || response.chats || []);
      }
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchChats();
    
    // Poll for new chats every 10 seconds
    const interval = setInterval(fetchChats, 10000);
    return () => clearInterval(interval);
  }, [fetchChats]);

  return {
    chats,
    loading,
    error,
    refresh: fetchChats
  };
};